import { HttpHeaders } from '@angular/common/http';

export interface JsonApiResult {
  data: JsonApiResource[];
  included: JsonApiResource[];
  jsonapi: {
    version: string;
    meta: {
      links: {
        self: string;
      };
    };
  };
  links: {
    self: {
      href: string;
    };
    next: {
      href: string;
    };
  };
}

export interface JsonApiResourceIdentifier {
  type: string;
  id: string;
}

export interface JsonApiResource extends JsonApiResourceIdentifier {
  attributes?: any;
  relationships?: any;
  meta?: any;
}

export const headers: HttpHeaders = new HttpHeaders({
  'Content-Type': 'application/vnd.api+json',
  Accept: 'application/vnd.api+json',
});
